export const PLAYER_CLASSNAME = '.j-player';
export const PLAYER_IN_INTRO_CLASSNAME = '.j-intro .j-player';
export const HERO_PLAYER_CONTAINER = '.c-hero__media-wrapper .j-player';
export const PLAYER_TV_CARD_RAIL_JS_CLASS = '.j-tv-card-rail';
export const CAROUSEL_ELEMENT_HOOK = '.j-player-carousel-element';
export const PLAYER_WITH_CAROUSEL_ID_JS_CLASS = 'j-player-with-carousel';
export const SAFARI_PLAYER_CARD_CLASS = 'c-player-card-safari';
export const HERO_PLAYLIST_HOOK = '.j-hero-playlist';

export const VIDEO_PLAYER_STATUS = Object.freeze({
  REPLAY_CLICK: 'replayClick',
  PLAY: 'play',
  COMPLETE: 'complete',
  AD_PLAY: 'adPlay',
  AD_LOADED: 'adLoaded',
  PAUSE: 'pause',
  INITIAL: 'initial',
  READY: 'ready',
  ERROR: 'CONTENT_ERROR_SHOW',
  AD_PAUSE: 'adPause',
  SETUP_ERROR: 'setupError',
  GENERIC_ERROR: 'error',
  AD_ERROR: 'adError',
  HLS_STATUS_ERROR: 'HLS_STATUS_ERROR',
  BEFORE_PLAY: 'beforePlay',
  AD_COMPLETE: 'adComplete',
  AD_TIME: 'adTime',
  THIRD_QUARTILE: 'third-quartile',
  RESIZE: 'resize',
});

export const VIDEO_PLAYER_STATE = Object.freeze({
  IDLE: 'idle',
  PLAYING: 'playing',
  PAUSED: 'paused',
});

export const VIDEO_PLAYER_POSITIONS = Object.freeze({
  STICKY: 'sticky',
  DEFAULT: 'default',
});

export const VIDEO_PLAYER_OBSERVER_OPTIONS = Object.freeze({
  threshold: [0.7, 0.5, 0.3],
});
export const VIDEO_PLAYER_OBSERVER_OPTIONS_MOBILE = Object.freeze({
  threshold: [0.6, 0.3, 0.1],
});

export const VIDEO_PLAYER_CONTEXT = Object.freeze({
  PAGE: 'page',
  STICKY: 'sticky',
});

export const VIDEO_PLAYER_PLAYERTYPE = Object.freeze({
  HERO: 'hero',
  LMP_STICKY: 'sticky lmp',
  RAIL: 'rail',
  STICKY: 'sticky',
  HERO_HP: 'hero - hp',
  STICKY_TRACK: '-sticky',
  CAROUSEL: 'carousel',
  BODY: 'body',
});

export const VIDEO_PLAYER_SETUP_DEFAULTS = Object.freeze({
  AUTOSTART: true,
  VOLUME_OVERRIDE: false,
  ID: '',
  LIVE: false,
  ADV_OFF: false,
  DOMAIN: 'sky',
  TRACK_DOMAIN: '',
  NEXT_VIDEO: false,
  COUNTDOWN: 5000,
  DAI_OFF: undefined,
  SOCIAL: undefined,
  MUTE: true,
});

export const VIDEO_ADVERTISING_CUSTOM_PARAM = 'insider';
export const VIDEO_PLAYER_CONTAINER_ID_PREFIX = 'video-player-';

export const $heroPlaylist = document.querySelector(HERO_PLAYLIST_HOOK);
export const HERO_PLAYLIST_DELAY = 3000;
